<template>
  <div class="home-page brick">
    <loader v-if="!posts.length"></loader>
    <div v-else>
      <posts-list
        :posts="posts"
        :updates="updates"
      ></posts-list>
    </div>
  </div>
</template>

<script>
import { loadData } from '@/store/actionTypes';
import PostsList from '@/components/PostsList';
import Loader from '@/components/Loader';

export default {
  name: 'home-page',
  components: {
    PostsList,
    Loader,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    posts() {
      return this.$store.state.postsLoaded && this.$store.state.posts;
    },
    updates() {
      return this.$store.getters.updates || {};
    },
  },
  watch: {
    user: {
      handler(user) {
        if (user) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      this.$store.dispatch(loadData);
    },
  },
};

</script>

<style>

.loader {
  margin: 50px auto 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/containers/HomePage.vue